import React, { Fragment, useEffect, useRef, useState } from 'react';

import useClickOutside from '@hooks/useClickOutside';

import { getShortName } from '@utils/Util';

import CommonImage from './CommonImage';

const CustomMultipleSelect = ({ optionMap, handleOption, selectedOptions, toggleIsShowAddModal }) => {
	const [options, setOptions] = useState({});
	const [isShowOptions, setIsShowOptions] = useState(false);
	const [isShowActiveChildOptions, setIsShowActiveChildOptions] = useState(null);

	const fileModalRef = useRef(null);

	const handleCloseTags = () => {
		setIsShowOptions(false);
		setIsShowActiveChildOptions(null);
	};

	useClickOutside(fileModalRef, handleCloseTags);

	useEffect(() => {
		setOptions(optionMap);
	}, [optionMap]);

	const handleSearch = (e) => {
		const { value } = e.target;
		if (value) {
			let tmpOptions = {};
			for (let key in optionMap) {
				let filteredOptions = optionMap[key].filter((option) =>
					option.label.toLowerCase().includes(value.toLowerCase())
				);
				if (filteredOptions.length > 0) {
					tmpOptions[key] = filteredOptions;
				}
			}
			setOptions(tmpOptions);
		} else {
			setOptions(optionMap);
		}
	};

	const renderOptions = () => {
		return Object.keys(options)?.map((key) => (
			<Fragment key={key}>
				<div className="sep" />
				<div className="menu-list-panel">
					<ul className="dropdown-list">
						<span className="label px-2 gray_dark_01 medium-14">{key}</span>
						{options?.[key]?.map((option) => (
							<Fragment key={option.id}>
								<li className="dropdown-list-item list-item cursor-pointer">
									<div className="start d-flex align-items-center justify-content-between">
										<span
											className="label"
											onClick={() => {
												if (option?.options === undefined) {
													handleOption(key, option);
												} else {
													if (isShowActiveChildOptions === option.id) {
														setIsShowActiveChildOptions(null);
													} else {
														setIsShowActiveChildOptions(option.id);
													}
												}
											}}
										>
											{getShortName(option.label, 30)}
										</span>
										{selectedOptions?.[key]?.find((item) => item.id === option.id) !==
											undefined && (
											<span className="tick">
												<CommonImage
													src="/icons/check24.svg"
													alt="check24.svg"
													width={16}
													height={16}
												/>
											</span>
										)}
										{option?.options?.length > 0 && (
											<span
												className="arrow"
												onClick={() => {
													if (isShowActiveChildOptions === option.id) {
														setIsShowActiveChildOptions(null);
													} else {
														setIsShowActiveChildOptions(option.id);
													}
												}}
											>
												<CommonImage
													src="/icons/right-arrow.svg"
													alt="arrow-right"
													width={16}
													height={16}
												/>
											</span>
										)}
									</div>
									{isShowActiveChildOptions === option.id && (
										<ul className="dropdown-child-list scroll-y-label">
											{option?.options?.map((childOption) => (
												<li
													className="dropdown-child-list-item list-item cursor-pointer"
													key={`${option.id}-${childOption.id}`}
													onClick={() => handleOption(key, option, childOption)}
												>
													<span className="label">{childOption?.label}</span>
												</li>
											))}
										</ul>
									)}
								</li>
							</Fragment>
						))}
					</ul>
				</div>
			</Fragment>
		));
	};

	const renderChips = () => {
		return Object.keys(selectedOptions)?.map((key) =>
			selectedOptions?.[key]?.map((option) => (
				<div className="chip" key={`${key}-${option.id}`}>
					<span
						className="label cursor-pointer"
						onClick={() => {
							if (option?.clickAbleLink) {
								window.open(option?.clickAbleLink, '_blank');
							}
						}}
					>
						{getShortName(option.label, 30)}
					</span>
					{!option?.hideCloseIcon && (
						<CommonImage
							className="cursor-pointer"
							src="/icons/close.svg"
							alt="close"
							width={16}
							height={16}
							onClick={() => handleOption(key, option)}
						/>
					)}
				</div>
			))
		);
	};

	return (
		<div className="multiple-select-component" ref={fileModalRef}>
			<div className="top">
				<span
					className="add-file-icon d-flex gray_dark_02 cursor-pointer"
					aria-hidden
					onClick={() => setIsShowOptions(!isShowOptions)}
				>
					<svg
						width="18"
						height="18"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<circle cx="12" cy="12" r="4" />
						<path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
					</svg>
				</span>
				<div className="chips d-flex flex-wrap align-items-center ml-2">{renderChips()}</div>
			</div>
			{isShowOptions && (
				<div className="menu">
					<div className="search-box">
						<input
							type="text"
							className="field"
							placeholder="Search..."
							onChange={handleSearch}
						/>
					</div>
					<div className="menu-list">
						<div
							className="cap add-file cursor-pointer"
							onClick={() => {
								toggleIsShowAddModal(true);
							}}
						>
							<CommonImage src="/icons/add.svg" alt="add" width={16} height={16} /> Add New
						</div>
						{renderOptions()}
					</div>
				</div>
			)}
		</div>
	);
};

export default CustomMultipleSelect;
